{
  "open": "Терминал",
  "connect": "Подключиться к серверу",
  "guest": "Гостям терминал недоступен",
  "picker": {
    "title": "Подключиться к серверу",
    "description": "Панель подключится к серверу — терминалом по SSH, удалённым рабочим столом Windows или консолью сервера — и покажет сеанс здесь. Сеанс работает, пока открыта вкладка браузера.",
    "project": "Проект",
    "search": "Найти сервер",
    "searchPlaceholder": "Имя или адрес",
    "servers": "Серверы",
    "noServers": "В проекте нет серверов.",
    "noMatch": "Ничего не найдено.",
    "noProjects": "Нет проектов, где вы можете открыть терминал: гостям он недоступен.",
    "off": "Сервер выключен",
    "noAddress": "Нет публичного адреса",
    "guestProject": "Вы гость в этом проекте",
    "otherServer": "Другой сервер",
    "user": "Пользователь Unix",
    "userHint": "По умолчанию root. Панель запомнит выбор для этого сервера.",
    "userInvalid": "Латинские буквы, цифры, «.», «-» и «_», до 32 символов.",
    "auth": "Как войти",
    "certificate": "Сертификат (рекомендуется)",
    "certificateHint": "Одноразовый ключ, подписанный центром сертификации вашей организации, действует 10 минут. Сервер должен доверять центру: см. «Терминал в браузере» на странице сервера.",
    "password": "Пароль",
    "passwordHint": "Пароль пользователя Unix нужен для одного входа: панель его не хранит и не записывает.",
    "passwordField": "Пароль пользователя",
    "submit": "Подключиться",
    "direct": "Вход: {{user}}, сертификат",
    "settings": "Настройки подключения к {{name}}",
    "certificateWorks": "Вход по сертификату на этот сервер работает (последний раз {{time}}).",
    "certificateUnknown": "Сервер ещё не принимал сертификат: сначала он должен доверять центру сертификации.",
    "setupLink": "Настройка на странице сервера"
  },
  "workspace": {
    "single": "Один",
    "columns": "Рядом",
    "rows": "Друг под другом",
    "second": "Другая панель",
    "layout": "Разделение экрана",
    "secondMenu": "Какой терминал во второй панели",
    "fontSmaller": "Шрифт меньше",
    "fontLarger": "Шрифт больше",
    "search": "Найти в выводе",
    "searchNext": "Следующее совпадение",
    "searchPrevious": "Предыдущее совпадение",
    "searchClose": "Закрыть поиск",
    "copy": "Копировать выделенное",
    "selectFirst": "Сначала выделите текст в терминале.",
    "paste": "Вставить",
    "pasteFailed": "Браузер не дал прочитать буфер обмена. Вставьте сочетанием Ctrl+Shift+V."
  },
  "failure": {
    "unreachable": {
      "title": "Сервер не отвечает на SSH",
      "text": "Панель не смогла подключиться к порту 22. Возможно, его закрывает файрвол или sshd не запущен."
    },
    "timeout": {
      "title": "Сервер не ответил вовремя",
      "text": "Соединение не установилось за 20 секунд. Проверьте файрвол и что сервер загрузился."
    },
    "auth_failed": {
      "title": "Неверный пароль",
      "text": "Сервер не принял пароль этого пользователя. Введите его ещё раз."
    },
    "certificate_not_trusted": {
      "title": "Сервер не доверяет центру сертификации",
      "text": "Сервер отказался от сертификата. Выполните на нём команду ниже (один раз, от root) или войдите по паролю."
    },
    "host_key_changed": {
      "title": "Ключ сервера изменился",
      "text": "Сервер показал другой ключ SSH, чем в прошлый раз. Так бывает после пересборки сервера — или при подмене соединения. Доверяйте новому ключу, только если сами меняли сервер."
    },
    "shell_failed": {
      "title": "Сервер не открыл командную строку",
      "text": "Вход прошёл, но оболочка не запустилась. Попробуйте другого пользователя или консоль."
    },
    "idle": {
      "title": "Сеанс закрыт из-за бездействия",
      "text": "В терминале 30 минут ничего не происходило. Переподключитесь, чтобы продолжить."
    },
    "lifetime": {
      "title": "Сеанс закончился",
      "text": "Сеанс может длиться до 8 часов. Переподключитесь — панель выдаст новый сертификат."
    },
    "closed": {
      "title": "Сеанс закрыт",
      "text": "Соединение завершилось. Переподключитесь, чтобы продолжить."
    },
    "expired": {
      "title": "Сеанс устарел",
      "text": "Ссылка на подключение уже использована или истекла. Переподключитесь."
    }
  },
  "hostKey": {
    "known": "Был",
    "offered": "Сейчас",
    "accept": "Доверять новому ключу"
  },
  "passwordRetry": "Войти по паролю",
  "setup": {
    "title": "Терминал в браузере",
    "intro": "Панель входит на сервер по SSH одноразовыми сертификатами центра сертификации вашей организации. Сервер должен доверять этому центру — один раз, командой ниже. Новые серверы с отметкой «Терминал в браузере» доверяют ему с первой загрузки.",
    "trusted": "Вход по сертификату работает: последний раз {{time}}.",
    "notYet": "Вход по сертификату на этот сервер ещё не проходил.",
    "command": "Команда для сервера",
    "commandHint": "Выполните от root (через SSH или консоль). Она записывает ключ центра в /etc/ssh, добавляет строку TrustedUserCAKeys в настройки sshd, проверяет их и перезагружает sshd; если sshd не примет настройки, всё останется как было.",
    "copy": "Скопировать команду",
    "copied": "Команда скопирована",
    "typeInConsole": "Набрать в консоли",
    "hostKey": "Ключ сервера (host key)",
    "hostKeyUnknown": "Появится после первого входа."
  },
  "reach": {
    "title": "Доступ к порту 22",
    "open": "Открыт для панели.",
    "blocked": "Закрыт файрволом: {{names}}. Панель не сможет подключиться.",
    "unknown": "Адрес панели не задан, поэтому проверить правила нельзя: порт 22 открыт не для всех.",
    "noAddress": "У сервера нет публичного адреса: терминалу не к чему подключиться.",
    "egress": "Адрес панели: {{ips}}",
    "allow": "Разрешить доступ с адреса панели",
    "allowHint": "Добавит в файрвол «{{name}}» правило: входящий TCP 22 с {{ips}}.",
    "allowed": "Правило добавлено в файрвол «{{name}}»"
  },
  "settings": {
    "title": "Настройки терминала",
    "description": "Шрифт, размер и цвета для всех терминалов в этом браузере. Изменения видны сразу, в том числе в открытых сеансах.",
    "searchHint": "Или Ctrl+Shift+F в терминале (⌘+Shift+F на Mac).",
    "preview": "Как это выглядит",
    "sampleWarn": "внимание",
    "sampleError": "ошибка",
    "sampleComment": "комментарий",
    "fontSize": "Размер шрифта",
    "fontSizeValue": "Размер шрифта: {{size}}",
    "font": "Шрифт",
    "systemFont": "Моноширинный шрифт системы",
    "noCyrillic": "без кириллицы",
    "theme": "Цветовая тема",
    "panelTheme": "Как в панели",
    "panelThemeHint": "Светлая или тёмная — вслед за темой панели",
    "dark": "Тёмные",
    "light": "Светлые",
    "reset": "Сбросить",
    "done": "Готово"
  },
  "touchKeys": {
    "label": "Клавиши терминала",
    "esc": "Escape",
    "tab": "Tab",
    "ctrl": "Ctrl: следующая клавиша с Ctrl",
    "alt": "Alt: следующая клавиша с Alt",
    "left": "Стрелка влево",
    "up": "Стрелка вверх",
    "down": "Стрелка вниз",
    "right": "Стрелка вправо",
    "slash": "Косая черта",
    "hideKeyboard": "Скрыть клавиатуру",
    "showKeyboard": "Показать клавиатуру"
  }
}
